import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const handleShare = async () => {
  const title = document.title
  const url = window.location.href

  if (navigator.share) {
    try {
      await navigator.share({
        title,
        url,
      })
      console.log('Content shared successfully')
    } catch (err) {
      console.log('Error sharing content:', err)
    }
  } else {
    // Fallback for browsers that don't support the Web Share API
    console.log('Web Share API not supported')
    // Copy URL to clipboard as fallback
    navigator.clipboard
      .writeText(url)
      .then(() => {
        alert('Link copied to clipboard!')
      })
      .catch(err => {
        console.error('Could not copy text: ', err)
      })
  }
}
